module.exports = __webpack_public_path__ + "img/otamerica_br_portuguese_2023_certification_badge.c9320efe.png";